<div class="signin-page-container">
  <div class="background-animation">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 178 100" class="animated-waves">
      <path
        fill="#2D5A68"
        class="bottom-1"
        d="M -24.38,77.75
               C -21.55,67.11 -6.09,61.32 11.50,60.88
                 27.39,60.47 33.62,66.25 53.25,60.25
                 62.88,57.00 76.75,55.62 87.75,57.25
                 98.75,58.88 115.50,54.25 123.50,54.75
                 133.00,55.75 156.75,57.00 164.25,61.75
                 171.00,65.75 196.93,68.32 193.50,71.75
                 187.50,77.75 179.88,122.25 161.25,124.25
                 142.62,126.25 82.75,115.50 75.12,113.25
                 67.50,111.00 -16.50,112.12 -27.50,108.62
                 -38.50,105.12 -29.75,98.00 -24.38,77.75 Z"
      />
      <path
        fill="#3F7086"
        class="bottom-2"
        d="M -17.62,79.25
               C -17.30,75.58 -2.25,69.80 8.75,68.50
                 21.09,66.85 27.00,65.25 35.25,66.00
                 43.25,66.88 57.00,66.50 67.25,63.25
                 76.25,60.00 91.25,62.12 101.25,61.75
                 110.50,62.25 127.00,61.38 133.50,65.50
                 139.50,69.75 154.75,69.75 167.25,70.50
                 176.75,71.25 199.12,72.62 198.50,76.00
                 197.88,79.38 174.25,122.50 168.75,123.75
                 163.25,125.00 77.75,104.00 60.12,105.00
                 42.50,106.00 -21.38,102.88 -24.88,102.75
                 -28.38,102.62 -18.25,86.38 -17.62,79.25 Z"
      />
      <path
        fill="#5186A4"
        class="bottom-3"
        d="M -10.88,84.62
               C -3.00,77.88 3.75,73.00 15.50,73.00
                 26.19,74.24 55.55,71.61 69.50,66.50
                 83.50,61.38 102.12,70.75 110.50,70.50
                 114.44,70.62 133.25,68.50 148.77,73.09
                 167.40,77.30 185.38,77.18 190.50,81.00
                 200.88,88.12 182.50,118.50 175.00,119.25
                 167.50,120.00 -20.88,105.12 -21.00,105.12
                 -21.12,105.12 -18.75,91.38 -10.88,84.62 Z"
      />
      <path
        fill="#639CC2"
        class="bottom-4"
        d="M 196.00,92.00
               C 196.00,92.00 183.50,89.50 174.58,83.43
                 164.75,77.75 139.00,72.42 127.25,75.50
                 108.50,81.25 99.09,76.87 81.75,74.50
                 69.58,72.84 13.23,77.85 4.62,81.25
                 -16.25,89.50 -24.88,92.25 -10.50,106.00
                 -2.42,113.73 136.03,141.92 171.50,134.00
                 199.16,127.82 196.00,92.00 196.00,92.00 Z"
      />
    </svg>
  </div>

  <div class="signup-card-container">
    <div class="signup-card">
      <div class="container">
        <div class="success-icon">
          <i class="pi pi-check-circle"></i>
        </div>
        <div class="title">
          <h2>Registration Submitted</h2>
        </div>
        <p>Your account request has been successfully submitted and is now pending admin approval. You'll receive an email notification once your account has been activated.</p>
        <p-button 
          label="Go to Sign In" 
          fluid="true"
          (onClick)="goToSignin()"
        ></p-button>
      </div>
    </div>
  </div>
</div>
